export const accountTypes = ['jupiter', 'b2c', 'wp', 'wp_sub_account'] as const;
export type AccountTypeValue = (typeof accountTypes)[number];

export const AccountType: Record<'JUPITER' | 'B2C' | 'WP' | 'WP_SUB_ACCOUNT', AccountTypeValue> = {
  JUPITER: 'jupiter',
  B2C: 'b2c',
  WP: 'wp',
  WP_SUB_ACCOUNT: 'wp_sub_account',
};
